import { limitOrderApiConnector } from 'apiConnector/secondary-market/limit-order/order';
import { isRejection } from 'epic/secondaryMarket/live/liveQuoteRequestEpic';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { limitOrderOrderActions } from 'state/secondaryMarket/limit-order/order/order.action';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabSetBusy } from 'state/workspaces/workspace.actions';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

export function limitOrderPlacementRequestEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient, getNow }) => {
    const { placeOrder: requestTrade } = limitOrderApiConnector(httpClient);
    return action$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_PLACEMENT_REQUESTED'),
      mergeMap(({ request, tabId, workspaceType }) => {
        return requestTrade(request).pipe(
          mergeMap(data =>
            of(
              limitOrderOrderActions.secondaryMarketOrderPlacementReceived(tabId, data, getNow()),
              workspaceTabSetBusy(tabId, workspaceType, false),
            ),
          ),
          catchError((error: HttpError) => {
            const message = extractHttpErrorMessage(error, { backend: 'domino' });
            if (isRejection(error) && message !== undefined) {
              return of(
                limitOrderOrderActions.secondaryMarketOrderPlacementRejected(tabId, message),
                workspaceTabSetBusy(tabId, workspaceType, false),
              );
            }
            return of(
              limitOrderOrderActions.secondaryMarketOrderPlacementFailed(tabId, message as string),
              workspaceTabSetBusy(tabId, workspaceType, false),
            );
          }),
        );
      }),
    );
  };
}
